import { Injectable, OnDestroy } from '@angular/core';
import { ClickEventHandlerService } from '../../../Bootstrap/services/click-event-handler.service';
import { Observable, Subject, Subscription } from 'rxjs';

@Injectable()
export class ClickOutsideService implements OnDestroy {
    subscriptions: Subscription[] = [];

    clickOutsideBlock$: Subject<boolean>;
    classComparisonRegex: RegExp;

    clickTargetOriginatedInsideApprovedArea: boolean;

    constructor(private clickEventService: ClickEventHandlerService) {
        this.clickOutsideBlock$ = new Subject();

        this.subscriptions.push(
            this.clickEventService.getClickListener().subscribe((event: Event) => this.handeClickEvent(event)),
            this.clickEventService.getMousedownListener().subscribe((event: Event) => this.handeMousedownEvent(event))
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    /**
     * Return provider for a click event outside block;
     */
    getClickOutsideBlock(): Observable<boolean> {
        return this.clickOutsideBlock$;
    }

    /**
     * Handles click event
     */
    handeClickEvent(event: Event) {
        if (!this.classComparisonRegex) {
            return;
        }

        const targetElement: HTMLElement = <HTMLElement>event.target;
        const classList = Array.from(targetElement.classList);
        const allInheritedClasses: string = this.getAllInheritedClasses(targetElement, classList).join(',');
        const clickTargetIsWithinBlock = allInheritedClasses.match(this.classComparisonRegex);
        // @HACK clicking body should really be possible, there is something wrong with click detection sometimes and it reports body, ignoring those clicks
        // safe enough, and avoids emitting when we shouldn't.  This is being added specifically in dealing with a problem when a dropdown is selected
        // inside the AI helper, and then the generate button is clicked... the generate button click is registered as a click against body
        const clickTargetIsBody: boolean = targetElement.tagName === 'BODY';

        if (!clickTargetIsWithinBlock && !this.clickTargetOriginatedInsideApprovedArea && !clickTargetIsBody) {
            this.clickOutsideBlock$.next(true);
        }
        this.clickTargetOriginatedInsideApprovedArea = false;
    }

    /**
     * Handles click event
     */
    handeMousedownEvent(event: Event) {
        if (!this.classComparisonRegex) {
            return;
        }

        const targetElement: HTMLElement = <HTMLElement>event.target;
        const classList = Array.from(targetElement.classList);
        const allInheritedClasses: string = this.getAllInheritedClasses(targetElement, classList).join(',');
        const mousedownTargetIsWithinApprovedArea = allInheritedClasses.match(this.classComparisonRegex);

        if (mousedownTargetIsWithinApprovedArea) {
            this.clickTargetOriginatedInsideApprovedArea = true;
        } else {
            this.clickTargetOriginatedInsideApprovedArea = false;
        }
    }

    /**
     * Returns an array of all parent classes
     */
    getAllInheritedClasses(element: HTMLElement, classList: string[]) {
        if (!element || !element.parentElement) {
            return classList;
        }

        const parentClassList: string[] = Array.from(element.parentElement.classList);
        classList.push(...parentClassList);

        return this.getAllInheritedClasses(element.parentElement, classList);
    }

    /**
     * Sets the regex to compare to target element
     */
    setClassComparisonRegex(regex: RegExp) {
        this.classComparisonRegex = regex;
    }

    /**
     * Removes the regex to compare to target element
     */
    removeClassComparisonRegex() {
        this.classComparisonRegex = null;
    }
}
